'use client';

import { c as _c } from "react/compiler-runtime";
import { Search } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
import { SuggestionWorld } from '@/hooks/useWorldFuzzySearch';
import { Link } from '@/i18n/navigation';
import { MouseEvent } from 'react';
type OtherSearchedForProps = {
  data: SuggestionWorld[];
};
export default function OtherSearchedFor(t0) {
  const $ = _c(19);
  const {
    data: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const data = t2;
  const t = useTranslations();
  const {
    startSearch,
    setIsSearchSidebarOpen
  } = useWorldSearchContext();
  let t3;
  if ($[2] !== setIsSearchSidebarOpen || $[3] !== startSearch) {
    t3 = (e, value) => {
      e.preventDefault();
      startSearch(value, {
        onAfterNavigate: () => {
          setIsSearchSidebarOpen(false);
        }
      });
    };
    $[2] = setIsSearchSidebarOpen;
    $[3] = startSearch;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const onSearchClick = t3;
  let t4;
  if ($[5] !== t) {
    t4 = t("worlds-landing.search.others-searched-for");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="mb-4"><h3 className="subheader-3 text-vive-primary-40">{t4}</h3></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== data || $[10] !== onSearchClick) {
    let t7;
    if ($[12] !== onSearchClick) {
      t7 = (item, index) => <Link href={`/search?keyword=${item.title}`} key={index} className="hover:bg-vive-primary-50/10 flex cursor-pointer items-center gap-3 rounded-lg p-2 transition-all duration-300 hover:shadow-lg" onClick={e_0 => onSearchClick(e_0, item.title)}><Search className="text-vive-primary-20 size-5" /><span className="body-2">{item.title}</span></Link>;
      $[12] = onSearchClick;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    t6 = data.map(t7);
    $[9] = data;
    $[10] = onSearchClick;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <div className="flex flex-col gap-4 pb-20">{t6}</div>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className="lg:w-[264px]"><div className="sticky top-26">{t5}{t7}</div></div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}